import { motion } from "framer-motion";
import React from "react";
import CTAsec from "../../components/CTAsec";
import Clientes from "./Clientes";
import Hero from "./Hero";
import Ingresos from "./Ingresos";
import Impacto from "./Impacto";
import Modalidades from "./Modalidades";
import JoinUs from "./JoinUs";

const Home = ({ variants }) => {
  return (
    <>
      <motion.div
        className={"transition"}
        initial={{ x: 0 }}
        animate={{ x: "100%" }}
        exit={{ x: 0 }}
        transition={{
          transition: 3,
          type: "spring",
          stiffness: 200,
        }}
      />
      <div className="containerDiv">
        <Hero variants={variants} />
        <Clientes variants={variants} />
        <Impacto variants={variants} />
        <Modalidades variants={variants} />
        <Ingresos variants={variants} />
        <JoinUs variants={variants} />
        <CTAsec type={"link"} href={"/contacto"} variants={variants} />
      </div>
    </>
  );
};

export default Home;
